import { Button as ButtonComponent } from 'antd';

const Button = ({ onClick, className, type, children, ...props }) => {
  return (
    <ButtonComponent
      className={`${className} ${props?.loading ? 'cursor-wait' : ''}`}
      type={type ?? ''}
      {...props}
      onClick={onClick}
    >
      {children}
    </ButtonComponent>
  );
};

export default Button;
